import React, { memo } from 'react';
import PlanCard from '../../shared/PlanCard';
import EntitlementsSection from './EntitlementsSection';
import type { OrderedPlan, FeatureSection, PlanId, Feature } from '../../types';

interface PlanPanelProps {
  plan: OrderedPlan;
  featureSections: FeatureSection[];
  currentPlan: PlanId;
  price: string | null;
  onSelectFeature: (feature: Feature) => void;
}

const PlanPanel: React.FC<PlanPanelProps> = ({
  plan,
  featureSections,
  currentPlan,
  price,
  onSelectFeature,
}) => {
  const { id } = plan;
  const isCurrent = id === currentPlan;

  return (
    <>
      <PlanCard plan={plan} isCurrent={isCurrent} price={price} />
      <EntitlementsSection
        featureSections={featureSections}
        featureKey={id}
        planName={plan.cardTitle}
        onSelectFeature={onSelectFeature}
      />
    </>
  );
};

export default memo(PlanPanel);
